// Nothing to import here
import './style.less';



// WEBPACK FOOTER //
// ./src/customer/styles/style.js